export default function PHP_Do_While_Loop() {
  return (
    <div>
      <h1>PHP_Do_While_Loop</h1>
    </div>
  );
}
